import React, {ElementType} from 'react';

interface Props {
  arr: string[];
  as: ElementType;
  conjunction: string;
}

export default function ArrayToReadableFragment({
  arr = [],
  as: WrapperElement = 'span',
  conjunction = 'and'
}: Props) {
  if (arr.length === 0) {
    return '';
  }

  if (arr.length === 1) {
    return <WrapperElement>{arr[0]}</WrapperElement>;
  }
  return (
    <>
      <WrapperElement>{arr.slice(0, -1).join(', ')} </WrapperElement>
      {conjunction}
      <WrapperElement> {arr[arr.length - 1]}</WrapperElement>
    </>
  );
}
